import _ from 'lodash';
import { ToolkitApi } from '@/app/services/api/toolkit';
import { getDefaultItem } from '@/app/utils/toolkit/defaultItems';

export default {
  name: 'shared-item',
  data: () => ({
    loading: false,
  }),
  props: {
    share: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handleView() {
      try {
        this.$store.dispatch('toggleLoading', true, { root: true });
        const response = await ToolkitApi.getItem(this.share.sharedObject);
        if (response.status === 200) {
          const item = response.data.data;
          const itemType = item.type === 'COVID' ? 'RENT_RELIEF' : item.type;
          const itemKey = ToolkitApi.getItemType(itemType);
          if (itemKey.type === 'RENT_RELIEF') {
            itemKey.key = 'covid';
          } else if (itemKey.type === 'PENSION_ESTABLISHMENT') {
            itemKey.key = 'data';
          }

          this.$store.dispatch('fund/loadFund', {
            uuid: item.uuid,
            status: item.status,
            cognitoID: item.cognitoID,
            relation: item.relation,
            ...item.fund,
          });

          const defaultInvItem = _.cloneDeep(getDefaultItem(itemType));

          await this.$store.dispatch('toolkit/loadItem', {
            uuid: item.uuid,
            type: itemType,
            grant_type: 'SHARE',
            status: item.status,
            accountID: item.relation,
            cognitoID: item.cognitoID,
            relation: item.relation,
            data: _.merge(defaultInvItem, item.data),
          });
          this.$router.push('/fund/review');
          this.$store.dispatch('toggleLoading', false, { root: true });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    if (
      this.$route.query.shareID
      && this.$route.query.shareID === this.share.sharedPermission.shareUUID
    ) {
      this.handleView();
    }
  },
};
